// Filtre les cartes produit d'une collection par catégorie (côté navigateur, instantané).
// Aucun réglage Shopify requis. Délégué au document.
document.addEventListener('click', (event) => {
  const pill = event.target.closest('.coll-pill[data-type]');
  if (!pill) return;

  event.preventDefault();

  const bar = pill.closest('.coll-pills');
  const grid = document.querySelector('[data-ref="main-collection-grid"]');
  if (!bar || !grid) return;

  const type = pill.dataset.type || '';
  bar.querySelectorAll('.coll-pill').forEach((p) => p.classList.toggle('on', p === pill));

  let shown = 0;
  grid.querySelectorAll('.cpc').forEach((card) => {
    const match = type === '' || card.dataset.type === type;
    card.style.display = match ? '' : 'none';
    if (match) shown += 1;
  });

  const count = document.querySelector('.coll-count');
  if (count) count.textContent = shown + (shown > 1 ? ' produits' : ' produit');
});
